const PhotoSwipe = window.PhotoSwipe
const PhotoSwipeLightbox = window.PhotoSwipeLightbox

export class ProductPhotoSwipe extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els?.link?.exists) return

    this.photoSwipeInstance = new PhotoSwipeLightbox({
      loop: false,
      showAnimationDuration: 500,
      scaleMode: 'zoom',

      gallery: this,
      children: this.els.link.selector,
      bgOpacity: 1,
      arrowPrev: false,
      arrowNext: false,
      zoom: false,
      close: false,
      counter: false,
      preloadFirstSlide: true,
      closeOnVerticalDrag: true,
      tapAction: 'zoom',

      pswpModule: () => {
        return PhotoSwipe
      },
    })

    this.setupPhotoSwipeListeners()
    this.photoSwipeInstance.init()
  }

  setupListeners () {
    super.setupListeners()

    this.onTriggerClick = this.onTriggerClick.bind(this)
    this.listeners.add(document, 'click', this.onTriggerClick.bind(this))
  }

  onTriggerClick (event) {
    if (!event.target.closest(this.externalEls?.trigger?.selector)) return

    const index = event.target.closest(this.externalEls?.trigger?.selector)
      .dataset.index

    const link = document.querySelector(
      `${this.els?.link?.selector}[data-index="${index}"]`,
    )

    if (!link) return

    link.click()
  }

  setupPhotoSwipeListeners () {
    this.photoSwipeInstance.on('uiRegister', () => {
      this.addCloseButton()
      this.addDots()
      this.addNextPrev()
    })
  }

  addCloseButton () {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'custom-close',
      className: 'pswp-Action_Close',
      ariaLabel: 'Minimise image gallery',
      order: 2,
      isButton: true,
      html: this.closeSvg,
      onClick: () => {
        this.photoSwipeInstance.pswp.close()
      },
    })
  }

  addDots () {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'dots',
      className: 'pswp-Action_Dots',
      appendTo: 'wrapper',
      onInit: (element, pswp) => {
        const dotEls = []
        let thumbEl
        let dotEl
        let previousIndex = -1

        for (let i = 0; i < pswp.getNumItems(); i++) {
          dotEl = document.createElement('button')
          dotEl.type = 'button'
          dotEl.className = 'pswp-Action_Dot'
          dotEl.setAttribute(
            'aria-label',
            `Show product media thumbnail ${i + 1}`,
          )
          dotEl.onclick = (event) => {
            pswp.goTo(dotEls.indexOf(event.target))
          }

          thumbEl = document.createElement('img')
          thumbEl.className = 'pswp-Action_DotImage'
          thumbEl.src = this.els.link.elements[i].dataset.thumbImage

          dotEl.appendChild(thumbEl)
          element.appendChild(dotEl)

          dotEls.push(dotEl)
        }

        pswp.on('change', () => {
          if (previousIndex >= 0) {
            dotEls[previousIndex].setAttribute('aria-current', 'false')
          }
          dotEls[pswp.currIndex].setAttribute('aria-current', 'true')
          previousIndex = pswp.currIndex
        })
      },
    })
  }

  addNextPrev () {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'paging',
      className: 'pswp-Action_Buttons',
      appendTo: 'wrapper',
      onInit: (element, pswp) => {
        const prevEl = document.createElement('button')
        prevEl.type = 'button'
        prevEl.className = 'pswp-Action_Button'
        prevEl.textContent = window.theme.strings.previous
        prevEl.onclick = () => {
          pswp.goTo(pswp.currIndex - 1)
        }

        const nextEl = document.createElement('button')
        nextEl.type = 'button'
        nextEl.className = 'pswp-Action_Button'
        nextEl.textContent = window.theme.strings.next
        nextEl.onclick = () => {
          pswp.goTo(pswp.currIndex + 1)
        }

        element.appendChild(prevEl)
        element.appendChild(nextEl)

        pswp.on('change', () => {
          prevEl.setAttribute('aria-hidden', pswp.currIndex === 0)
          nextEl.setAttribute(
            'aria-hidden',
            pswp.currIndex + 1 === pswp.getNumItems(),
          )
        })
      },
    })
  }

  get closeSvg () {
    return `
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 15 15">
        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M2 13 13 2M13 13 2 2"/>
      </svg>
    `
  }
}

if (!customElements.get('product-photoswipe')) {
  customElements.define('product-photoswipe', ProductPhotoSwipe)
}
